import './RadioButton.css';
import { ChangeEventHandler, ReactNode } from 'react';

type RadioButtonProps = {
	children: ReactNode;
	group: string;
	value: string;
	className?: string;
	onChange?: ChangeEventHandler<HTMLInputElement>;
	onBlur?: ChangeEventHandler<HTMLInputElement>;
	checked?: boolean;
	disabled?: boolean;
};

export const RadioButton = ({
	children,
	group,
	value,
	className = '',
	onChange,
	checked = false,
	onBlur,
	disabled = false,
}: RadioButtonProps): JSX.Element => {
	const id = `${group}-${value}`;

	return (
		<div className={'radio-button ' + className}>
			<input
				id={id}
				type="radio"
				name={group}
				value={value}
				checked={checked}
				onChange={onChange}
				onSelect={onChange}
				onBlur={onBlur}
				disabled={disabled}
			/>
			<label htmlFor={id} className={checked ? 'radio-button-selected radio-button-label' : 'radio-button-label'}>
				{children}
			</label>
		</div>
	);
};
